export default "__VITE_ASSET__1178a35b__"